import PoolDescription, { I18N_CONTEXT } from './crowdfunding_story'
import { getI18n } from 'client/i18n'
import { reduxForm, initialize, change } from 'redux-form'
import { CROWDFUNDING_DESCRIPTION_LENGTH } from 'shared/lengths'
import { required, length, combine } from 'lib/validators'
import formUtils from 'lib/form_utils'
import { push } from 'react-router-redux'

import { NEW_CAMPAIGN_ID, setData } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'

const i18n = getI18n(I18N_CONTEXT)

const validators = [
  required('description', i18n('description_required')),
  length(
    'description',
    CROWDFUNDING_DESCRIPTION_LENGTH,
    i18n('description_too_long', {
      maxLength: CROWDFUNDING_DESCRIPTION_LENGTH,
    })
  ),
]

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)

  return {
    shouldAutoFocus: props.router.params.action !== 'POP',
    initialValues: {
      description: campaign.description,
    },
    charity: campaign.charity,
    npid: campaign.npid,
    description: campaign.description,
    type: campaign.type,
  }
}

const mapDispatchToProps = dispatch => {
  // event_name is hardcoded for crowdfunding phase 1
  return {
    onSubmit(formValues) {
      dispatch(
        setData(NEW_CAMPAIGN_ID, {
          description: formValues.description,
          event_name: 'COVID-19',
        })
      )
      dispatch(
        push({
          pathname: `${
            GLOBAL_CONSTS.REQUEST_URI
          }/c/create-crowdfunding/select-cover`,
        })
      )
    },
    initializeForm: data => initialize('crowdfunding_story', data),
    handleChange: (field, value) => change('crowdfunding_story', field, value),
  }
}

export default reduxForm(
  {
    form: 'crowdfunding_story',
    destroyOnUnmount: false,
    fields: ['description'],
    touchOnBlur: true,
    touchOnChange: false,
    validate: combine(...validators),
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(PoolDescription))
